import React, { useState } from 'react'; // ← Aggiungi useState
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { getEventImageUrl, getPlaceholderImage } from '../utils/imageUtils';
import EventModal from './EventModal'; // ← NUOVO IMPORT

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SliderContainer = styled.div`
  .swiper {
    padding: 20px 0 50px 0;
  }
  
  .swiper-slide {
    height: auto;
  }
  
  .swiper-pagination {
    bottom: 10px !important;
  }
  
  .swiper-pagination-bullet {
    background: #FF9500;
    opacity: 0.5;
    width: 10px;
    height: 10px;
  }
  
  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #FF9500;
  }
  
  .swiper-button-next,
  .swiper-button-prev {
    color: #FF9500;
    font-weight: bold;
    
    &::after {
      font-size: 20px;
    }
    
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

const EventCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  height: 100%;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }
`;

const EventImage = styled.div`
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
  background-color: #f8f9fa;
  background-image: ${props => props.image ? `url(${props.image})` : 'linear-gradient(135deg, #FF9500, #FFB84D)'};
  transition: all 0.3s ease;
  
  &::after {
    content: ${props => !props.image ? '"📅"' : '""'};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 3rem;
    opacity: 0.7;
    color: white;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  }

  /* Overlay scuro per migliorare la leggibilità del badge */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 50px;
    background: linear-gradient(135deg, rgba(0,0,0,0.3) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const EventBadge = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  background: #FF9500;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  z-index: 2;
`;

const EventContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px);
`;

const EventTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const EventDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 15px;
`;

const EventDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #666;
  
  i {
    width: 14px;
    color: #FF9500;
    flex-shrink: 0;
  }
  
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const EventDescription = styled.p`
  font-size: 0.9rem;
  color: #777;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
    flex-grow: 1;
`;

const LoadingCard = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e9ecef;
    border-top: 4px solid #FF9500;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const ErrorCard = styled.div`
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  color: #c53030;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  i {
    font-size: 2rem;
    margin-bottom: 10px;
  }
`;

const ImageLoadingState = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #FF9500;
  font-size: 1.5rem;
  z-index: 1;
  
  .spinner {
    width: 30px;
    height: 30px;
    border: 3px solid #e9ecef;
    border-top: 3px solid #FF9500;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

function EventsSlider({ events, loading, error }) {
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState(null); // ← NUOVO STATE
  const [isModalOpen, setIsModalOpen] = useState(false); // ← NUOVO STATE

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Data non disponibile';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT', {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'Data non valida';
    }
  };

  const formatPrice = (price) => {
    if (price === null || price === undefined) return 'GRATIS';
    if (price === 0) return 'GRATIS';
    return `€${price}`;
  };

  // Componente per gestire il caricamento delle immagini
  const EventImageComponent = ({ event, ...props }) => {
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const [imageError, setImageError] = React.useState(false);
    const [imageSrc, setImageSrc] = React.useState(null);

    React.useEffect(() => {
      // Usa 'small' per le card dello slider per performance migliori
      const imageUrl = getEventImageUrl(event, 'small');
      
      if (imageUrl) {
        // Preload dell'immagine
        const img = new Image();
        img.onload = () => {
          setImageSrc(imageUrl);
          setImageLoaded(true);
          setImageError(false);
        };
        img.onerror = () => {
          console.warn(`Errore caricamento immagine per evento ${event.id}:`, imageUrl);
          // Prova con il placeholder
          const placeholderUrl = getPlaceholderImage(event);
          setImageSrc(placeholderUrl);
          setImageError(true);
          setImageLoaded(true);
        };
        img.src = imageUrl;
      } else {
        // Nessuna immagine disponibile, usa placeholder
        const placeholderUrl = getPlaceholderImage(event);
        setImageSrc(placeholderUrl);
        setImageLoaded(true);
      }
    }, [event]);

    return (
      <EventImage image={imageSrc} {...props}>
        {!imageLoaded && (
          <ImageLoadingState>
            <div className="spinner"></div>
          </ImageLoadingState>
        )}
        <EventBadge>{formatPrice(event.ticketPrice)}</EventBadge>
      </EventImage>
    );
  };

  // Configurazione Swiper responsive
  const swiperConfig = {
    modules: [Navigation, Pagination, Autoplay],
    spaceBetween: 20,
    pagination: {
      clickable: true,
      dynamicBullets: true,
    },
    navigation: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    loop: events.length > 3,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  };

  if (loading) {
    return (
      <SliderContainer>
        <Swiper {...swiperConfig}>
          {[...Array(5)].map((_, index) => (
            <SwiperSlide key={index}>
              <LoadingCard>
                <div className="spinner"></div>
              </LoadingCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </SliderContainer>
    );
  }

  if (error) {
    return (
      <SliderContainer>
        <ErrorCard>
          <i className="fas fa-exclamation-triangle"></i>
          <h3>Errore nel caricamento degli eventi</h3>
          <p>Non è stato possibile caricare gli eventi. Riprova più tardi.</p>
        </ErrorCard>
      </SliderContainer>
    );
  }

  if (!events || events.length === 0) {
    return (
      <SliderContainer>
        <ErrorCard>
          <i className="fas fa-calendar-times"></i>
          <h3>Nessun evento futuro disponibile</h3>
          <p>Al momento non ci sono eventi in programma da oggi in poi.</p>
        </ErrorCard>
      </SliderContainer>
    );
  }

  return (
    <>
      <SliderContainer>
        <Swiper {...swiperConfig}>
          {events.map((event) => (
            <SwiperSlide key={event.id}>
              <EventCard onClick={() => handleEventClick(event)}>
                <EventImageComponent event={event} />
                <EventContent>
                  <EventTitle>{event.title}</EventTitle>
                  <EventDetails>
                    <EventDetail>
                      <i className="fas fa-calendar"></i>
                      <span>{formatDate(event.startDate)}</span>
                    </EventDetail>
                    <EventDetail>
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{event.location || 'Luogo da definire'}</span>
                    </EventDetail>
                    {event.categories && event.categories.length > 0 && (
                      <EventDetail>
                        <i className="fas fa-tag"></i>
                        <span>{event.categories[0].name}</span>
                      </EventDetail>
                    )}
                  </EventDetails>
                  <EventDescription>
                    {event.description || 'Descrizione non disponibile.'}
                  </EventDescription>
                </EventContent>
              </EventCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </SliderContainer>

      {/* ← NUOVO MODAL */}
      <EventModal 
        event={selectedEvent}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
}
export default EventsSlider;
